export const PASSWORD_POLICY_MESSAGE = (
  'Password must be at least 8 characters and include an uppercase letter, a lowercase letter, and a number or symbol.'
);

export function getPasswordPolicyError(password) {
  if (!password) return '';
  const hasSymbol = /[^A-Za-z0-9\s]/.test(password);
  const valid = (
    password.length >= 8
    && /[A-Z]/.test(password)
    && /[a-z]/.test(password)
    && (/[0-9]/.test(password) || hasSymbol)
  );
  return valid ? '' : PASSWORD_POLICY_MESSAGE;
}
